export const calendarFeatureKey = ['calendar'] as const;
